import { HOME_TABS, TABS_CONSTANTS } from '../const';

export const filterTabsByUserConfig = classroomTabs => {
  return [TABS_CONSTANTS.MY_CLASSROOMS, ...classroomTabs.filter(classroomTab => HOME_TABS.includes(classroomTab))];
};
